import React, {Component} from 'react'
import StyleSheet from 'styles'
import { connect } from 'react-redux'
import Dependent from 'containers/shared/Dependent'
import { DealSheetActions } from 'actionsets'
import { KeyInformation, Progress, FeaturedDealSheetCard, Partners } from 'components/deal_sheet'
import { CenteredContent } from 'containers'
import Details, {InvestorInfo} from 'components/deal_sheet/details'
import AllocationButton from './AllocationButton'

export class Show extends Component{

  constructor(props){
    super(props)
    DealSheetActions.bindActions(this)
  }

  state = {}

  dependsOn(){
    return this.actions.show({id: this.dealSheetId})
  }

  dependenciesMet(){
    return (!!this.props.dealSheet.id)
  }

  get dealSheetId(){
    return this.props.match.params.id
  }

  get dealType() {
    return this.props.dealSheet.typeOfIssuance
  }

  render = () =>
    <div className={styles.content}>
      <FeaturedDealSheetCard dealSheet={this.props.dealSheet}/>
      <CenteredContent>
        <div className={styles.flexContainer}>
          <div className={styles.keyInfo}>
            <KeyInformation dealSheet={this.props.dealSheet}/>
            {this.dealType === 'product' && (
              <AllocationButton color="primary" variant="contained" fullWidth/>
            )}
          </div>
          <div className={styles.progressAndApply}>
            {this.dealType === 'product' ? (
              <InvestorInfo dealSheet={this.props.dealSheet}/>
            ) : (
              <Progress className={styles.progress} raised={this.props.dealSheet.amountRaised} cap={this.props.dealSheet.saleCap} currency={this.props.dealSheet.currency.code} />
            )}
            {this.dealType !== 'product' && (
              <AllocationButton color="primary" variant="contained" fullWidth/>
            )}
          </div>
        </div>

        {this.dealType !== 'product' && (
          <Details className={styles.details} dealSheet={this.props.dealSheet} />
        )}

        <Partners partners={this.props.dealSheet.partners}/>
      </CenteredContent>
    </div>
}

const styles = StyleSheet({
  flexContainer: {
    paddingTop: 75,
    '@media(max-width: 600px)': {
      paddingTop: 35,
    },
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -65px',
    overflow: 'hidden',
  },
  keyInfo: {
    padding: '0 65px'
  },
  progress: {
    flex: 1,
    paddingBottom: 30,
  },
  progressAndApply: {
    flex: 1,
    paddingTop: 18,
    paddingBottom: 30,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 400,
    padding: '0 65px',
    borderLeft: '1px solid #e8e8e8',
    '@media(max-width: 600px)': {
      minWidth: 250,
    }
  },
  details: {
    paddingTop: 100,
    minHeight: 300,
    '@media(max-width: 600px)': {
      paddingTop: 20,
    }
  },
  flex: {
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    flex: 1,
    '@media(max-width: 600px)': {
      margin: 0
    }
  },
  sticky: {
    boxShadow: 'none !important',
    top: 80,
    '@media(max-width: 600px)': {
      top: 65
    }
  },
  content: {
    width: '100%',
    boxSizing: 'border-box',
    paddingBottom: 75,
    '@media(max-width: 600px)': {
      paddingBottom: 0,
    }
  },
  wrapper: {
    width: '100%',
    boxSizing: 'border-box',
  },
})


export default connect(({dealSheets, nominations}) => { return {...dealSheets, nominations}})(Dependent({loader: true, wrapperClassName: styles.wrapper})(Show))